import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from 'moment-timezone';
import { db } from './firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';
import { Modal, Box, Container, Typography, Card, CardContent, Chip, Pagination } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AlertComponent from './AlertComponent';
import LoanFormReadonly from './LoanFormReadonly';
import './Calendar.css';

const ReadOnlyCalendarEmbed = () => {
  const [events, setEvents] = useState([]);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventModalIsOpen, setEventModalIsOpen] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', type: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = 5;

  useEffect(() => {
    const allowedDomains = ['salesforce.com', 'force.com'];
    const referrer = document.referrer;
    const authorized = allowedDomains.some(domain => referrer.includes(domain));
    // const authorized = true;
    setIsAuthorized(authorized);

    if (authorized) {
      const unsubscribe = onSnapshot(collection(db, 'events'), (snapshot) => {
        const eventsData = snapshot.docs.map(doc => ({
          id: doc.id,
          title: doc.data().extendedProps.clientName,
          start: doc.data().start.toDate(),
          end: doc.data().start.toDate(),
          extendedProps: doc.data().extendedProps
        }));
        setEvents(eventsData);
      });

      return () => unsubscribe();
    }
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const openEventModal = (info) => {
    setSelectedEvent({
      id: info.event.id,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      extendedProps: info.event.extendedProps
    });
      setEventModalIsOpen(true);
  };

  const futureEvents = events.filter(event => new Date(event.start) >= new Date())
    .sort((a, b) => new Date(a.start) - new Date(b.start));

  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = futureEvents.slice(indexOfFirstEvent, indexOfLastEvent);

  if (!isAuthorized) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h6" color="error" align="center">
          Acceso no autorizado. Este contenido solo puede ser visualizado desde Salesforce.
        </Typography>
      </Container>
    );
}

  return (
    <Container sx={{ mt: 2 }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      <img src="https://calendariocierre.vigmortgage.com/logo.png" alt="Logo" style={{ width: '60px', height: 'auto' }} />
    </Box>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        events={events}
        eventClick={openEventModal}
        editable={false}
        droppable={false}
        displayEventTime={false}
        height="auto"
        aspectRatio={1.0}
      />

    <Box sx={{ mt: 4, backgroundColor: '#f0f4f8', p: 2, borderRadius: 2, boxShadow: 3, mb: 4 }}>
      <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 'bold', color: '#0b6fae' }}>Próximos Eventos</Typography>

        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>

      {currentEvents.map(event => (
            <Card key={event.id} onClick={() => openEventModal(event)} sx={{ cursor: 'pointer', transition: '0.3s', '&:hover': { boxShadow: 6, transform: 'translateY(-5px)' } }}>
          <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <EventNoteIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{event.title}</Typography>
            </Box>
            <Chip label={moment(event.start).format('DD/MM/YYYY HH:mm')} color="secondary" size="small" />
          </CardContent>
        </Card>
      ))}
      </Box>

      <Pagination
          count={Math.ceil(futureEvents.length / eventsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
        />
      </Box>

      <Modal open={eventModalIsOpen} onClose={() => setEventModalIsOpen(false)}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: '90%', sm: 400 }, height: { xs: '90%', sm: 'auto' }, overflowY: 'auto', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
          <LoanFormReadonly
            user={{ role: 'readonly' }}
            selectedDate={selectedEvent ? selectedEvent.start : null}
            closeModal={() => setEventModalIsOpen(false)}
            isOpen={eventModalIsOpen}
            selectedEvent={selectedEvent}
            onAlert={(msg, type) => setAlert({ open: true, message: msg, type })} />
          </Box>
        </Modal>
  
        <AlertComponent
          open={alert.open}
          message={alert.message}
          type={alert.type}
          handleClose={() => setAlert({ ...alert, open: false })}
        />
    </Container>
  );
};

export default ReadOnlyCalendarEmbed;
